import { render } from "./PuntoPickDepto.vue?vue&type=template&id=33257042"
import script from "./PuntoPickDepto.vue?vue&type=script&lang=ts"
export * from "./PuntoPickDepto.vue?vue&type=script&lang=ts"
script.render = render

export default script